export const WHATSAPP_NUMBER = '918660175519';
export const WHATSAPP_DISPLAY = '+91 86601 75519';

export function getWhatsAppUrl(message = 'Hi! I want to know more about MSMECenter services.') {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function openWhatsApp(message) {
  const url = getWhatsAppUrl(message);
  if (typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  return url;
}

export function WhatsAppIcon({ className = 'w-5 h-5 fill-current' }) {
  return (
    <svg className={className} viewBox="0 0 24 24">
      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.724-1.455L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.37 9.864-9.799.002-2.63-1.023-5.101-2.885-6.965C16.588 2.015 14.135 1 12.004 1 6.572 1 2.147 5.37 2.143 10.8c-.001 1.702.462 3.368 1.34 4.844l-.997 3.638 3.738-.971" />
    </svg>
  );
}
